export default __webpack_public_path__ + "assets/images/ROIsColored-7fcd0eddfbc49c1f9b10df11cecf21c9.jpg";